
export const arrayShuffle = function(o) {
    for(var j, x, i = o.length; i; j = parseInt(Math.random() * i, 10), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
}

export const inArray = function(hay, needle) {
    return hay.indexOf(needle) === -1
}



// WEBPACK FOOTER //
// ./src/estimate_list/utils/array.js